import BlockRegistry from '../../BlockRegistry';

export function registerDCMotor() {
    BlockRegistry.register('dcMotor_dcMotor_setSpeed', (block, context) => {
        const pin = context.getInputValue(block, 'PIN');
        const speed = context.getInputValue(block, 'SPEED');

        context.addSetup(`pinMode(${pin}, OUTPUT);`);

        return `analogWrite(${pin}, ${speed})`;
    });

    BlockRegistry.register('dcMotor_dcMotor_stop', (block, context) => {
        const pin = context.getInputValue(block, 'PIN');

        context.addSetup(`pinMode(${pin}, OUTPUT);`);

        return `analogWrite(${pin}, 0)`;
    });
}
